import React, { useState, useEffect } from "react";
import { rolePermissions as initialRolePermissions } from "../../../../core/json/rolePermissions";
import { permissionTypes } from "../../../../core/json/permissionType";
import { assetPermissions } from "../../../../core/json/AssetPermissions";
import { rolesUsers } from "../../../../core/json/rolesUsers";
import { Link } from "react-router-dom";

const UserPermissions = () => {
  const storedRoleId = localStorage.getItem("selectedRole");

  // Map roleId to role string (assumes order or map structure)
  const roleMapping = {
    1: "Admin",
    2: "MaintenanceManager",
    3: "MaintenanceUser",
  };

  const defaultRole = roleMapping[storedRoleId] || "";
  const [selectedRole, setSelectedRole] = useState(defaultRole);
  const [selectedUser, setSelectedUser] = useState("");
  const [rolePermissions, setRolePermissions] = useState(
    initialRolePermissions
  );

  // Update selectedUser when role changes
  useEffect(() => {
    setSelectedUser(""); // reset user on role change
  }, [selectedRole]);

  // Toggle individual permission checkbox
  const togglePermission = (operationId, permId) => {
    setRolePermissions((prev) => {
      const rolePerms = prev[selectedRole] || {};
      const currentPerms = rolePerms[operationId] || [];

      let newPerms;
      if (currentPerms.includes(permId)) {
        // Remove permission
        newPerms = currentPerms.filter((id) => id !== permId);
      } else {
        // Add permission
        newPerms = [...currentPerms, permId];
      }

      return {
        ...prev,
        [selectedRole]: {
          ...rolePerms,
          [operationId]: newPerms,
        },
      };
    });
  };

  // Toggle "Allow All" checkbox for a given operation
  const toggleAllowAll = (operationId) => {
    setRolePermissions((prev) => {
      const rolePerms = prev[selectedRole] || {};
      const currentPerms = rolePerms[operationId] || [];

      const allPermIds = permissionTypes.map((p) => p.id);
      const hasAll = allPermIds.every((id) => currentPerms.includes(id));

      // If all are selected, remove all, else add all
      const newPerms = hasAll ? [] : allPermIds;

      return {
        ...prev,
        [selectedRole]: {
          ...rolePerms,
          [operationId]: newPerms,
        },
      };
    });
  };

  // Check if all permissions are allowed for the operation
  const isAllAllowed = (operationId) => {
    const rolePerms = rolePermissions[selectedRole] || {};
    const currentPerms = rolePerms[operationId] || [];
    const allPermIds = permissionTypes.map((p) => p.id);
    return allPermIds.every((id) => currentPerms.includes(id));
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    User Permissions
                  </h4>
                </ol>
              </nav>
              <h6>View and edit role-based permission matrix</h6>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="table-top mb-0 pt-1">
              <div className="search-set">
                <div className="search-input">
                  <a href="#" className="btn btn-searchset">
                    <i className="ti ti-search fs-14 feather-search" />
                  </a>
                  <div
                    id="DataTables_Table_0_filter"
                    className="dataTables_filter"
                  >
                    <label>
                      <input
                        type="search"
                        className="form-control form-control-sm"
                        placeholder="Search"
                        aria-controls="DataTables_Table_0"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="d-flex ">
                <div className="row mb-3">
                  {/* Select Role */}
                  <div className="col">
                    <label>Select Role:</label>
                    <select
                      className="form-select"
                      value={selectedRole}
                      onChange={(e) => setSelectedRole(e.target.value)}
                    >
                      <option value="">Select Role</option>
                      {rolesUsers.roles.map((role) => (
                        <option key={role} value={role}>
                          {role}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* <div className="col">
                <label>Role:</label>
                <input
                  type="text"
                  className="form-control"
                  value={selectedRole}
                  readOnly
                />
              </div> */}

                  {/* Select User based on Role */}
                  <div className="col">
                    <label>Select User:</label>
                    <select
                      className="form-select"
                      value={selectedUser}
                      onChange={(e) => setSelectedUser(e.target.value)}
                      disabled={!selectedRole}
                    >
                      <option value="">Select User</option>
                      {selectedRole &&
                        rolesUsers.users[selectedRole]?.map((user) => (
                          <option key={user} value={user}>
                            {user}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {selectedRole && selectedUser && (
              <table className="table ">
                <thead className="thead-light">
                  <tr>
                    <th>Menu</th>
                    <th>Operation</th>
                    {permissionTypes.map((perm) => (
                      <th key={perm.id}>{perm.label}</th>
                    ))}
                    <th>Allow All</th>
                  </tr>
                </thead>
                <tbody>
                  {assetPermissions.map((item) => {
                    const allAllowed = isAllAllowed(item.id);
                    return (
                      <tr key={item.id}>
                        <td>{item.menu}</td>
                        <td>{item.operation}</td>
                        {permissionTypes.map((perm) => (
                          <td key={perm.id}>
                            <div className="form-check form-check-md">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={
                                  rolePermissions[selectedRole]?.[
                                    item.id
                                  ]?.includes(perm.id) || false
                                }
                                onChange={() =>
                                  togglePermission(item.id, perm.id)
                                }
                              />
                            </div>
                          </td>
                        ))}
                        <td>
                          <div className="form-check form-check-md">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={allAllowed}
                              onChange={() => toggleAllowAll(item.id)}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}

            {!selectedRole && <p>Please select a role to begin.</p>}
            {selectedRole && !selectedUser && (
              <p>Please select a user to view permissions.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPermissions;
